<div class="wrap">
  <div class="header">
    <div class="title">
      <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active"
        appChangeColorTheme attribute="color"></fa-icon>
      <h2>{{title}}</h2>
    </div>

    <div class="search_bar">
      <form [formGroup]="searchForm" *ngIf="searchForm">
        <input type="text" placeholder="Chercher une modification..." (input)="applyFilter($event.target.value)"
          formControlName="keyword">
      </form>

      <fa-icon [icon]="getFaIcon('faTimes')" (click)="resetSearch()" class="faTimes" *ngIf="valueInput"></fa-icon>
      <fa-icon [icon]="getFaIcon('faSearch')" *ngIf="!valueInput"></fa-icon>

    </div>
  </div>

  <section [hidden]="modifications.length === 0 || isLoading">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">

      <ng-container matColumnDef="offerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Offre</th>
        <td mat-cell *matCellDef="let session"> {{ session.offerName }}</td>
      </ng-container>

      <ng-container matColumnDef="oldSession">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Précédente session </th>
        <td mat-cell *matCellDef="let session">{{ session.oldSession.dateLib}}
          <fa-icon [icon]="getFaIcon('faInfoCircle')" class="infos" appChangeColorTheme attribute="color"
            [matTooltip]="getTooltipSession(session.oldSession)" (click)="copyTooltip(session.oldSession)"></fa-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="newSession">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nouvelle session </th>
        <td mat-cell *matCellDef="let session"> {{ session.newSession.dateLib }}
          <fa-icon [icon]="getFaIcon('faInfoCircle')" class="infos" appChangeColorTheme attribute="color"
            [matTooltip]="getTooltipSession(session.newSession)" (click)="copyTooltip(session.newSession)"></fa-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="trainee">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Stagiaire </th>
        <td mat-cell *matCellDef="let session"> {{ session.trainee}} </td>
      </ng-container>

      <ng-container matColumnDef="customerFirstName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nom du client </th>
        <td mat-cell *matCellDef="let session"> {{ session.customerFirstName}} {{ session.customerLastName}} </td>
      </ng-container>

      <ng-container matColumnDef="customerEmail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
        <td mat-cell *matCellDef="let session"> {{ session.customerEmail}} </td>
      </ng-container>

      <ng-container matColumnDef="customerPhoneNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> N° de téléphone client</th>
        <td mat-cell *matCellDef="let session"> {{ session.customerPhoneNumber}} </td>
      </ng-container>

      <ng-container matColumnDef="notifierUserName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Notificateur</th>
        <td mat-cell *matCellDef="let session" class="alignCenter">
          <ng-container *ngIf="session.isCustomerNotified">
            {{ session.notifierUserName}}
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="plannerUserName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Planificateur</th>
        <td mat-cell *matCellDef="let session" class="alignCenter"> {{ session.plannerUserName}} </td>
      </ng-container>

      <ng-container matColumnDef="isCustomerNotified">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="notifCell">
          <mat-checkbox class="checkboxNotify" [ngModel]="checkboxNotify"
            (click)="$event.stopPropagation(); nextNotify($event)" [indeterminate]="checkboxNotify === false"
            [color]="color"
            [matTooltip]="checkboxNotify === null ? 'Filtrer par client notifié' : checkboxNotify === false ? 'Filtrer par client non notifié' : 'Sans filtre'">
          </mat-checkbox>
          Notifié
        </th>
        <td mat-cell *matCellDef="let session" class="notifCell">
          <mat-checkbox class="checkBox" [checked]="session.isCustomerNotified"
            (change)="notifyClient($event, session )"
            [matTooltip]="session.isCustomerNotified ? 'Retirer la confirmation de notification' : 'Confirmer la notification'"
            [color]="color"></mat-checkbox>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="header-row"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns;"
        [ngClass]="element.isCustomerNotified ? 'sessionCustomeNotified' : ''">
      </tr>
    </table>
    <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
      (page)="pageEvent = $event" [color]="color">
    </mat-paginator>
  </section>

  <mat-spinner *ngIf="isLoading" [diameter]="75"></mat-spinner>

  <ng-container *ngIf="modifications.length === 0 && !isLoading">
    <p>Il n'y a pas de modifications.</p>
  </ng-container>

</div>
